import FullPageLayout from "./full-page";
export default FullPageLayout;
